module.exports = __webpack_public_path__ + "static/media/delete-template.40f1050f.png";